import axios from 'axios';
import {ACTION_TYPES, createAction} from "../actions";
import { call, put, takeEvery} from 'redux-saga/effects'

export function* loadMapSaga () {
    yield takeEvery(ACTION_TYPES.FETCH_STYLE, loadMapStyle);
}

export function* loadMapStyle (action: any) {
    const { styleUrl, styleName } = action.payload;
    try {
        const defaultMapStyle = yield call(requestMapStyle, styleUrl);
        yield put(createAction(ACTION_TYPES.FETCH_STYLE_SUCCESS, {
            defaultMapStyle, styleName,
        }));
    } catch (error) {
        yield put(createAction(ACTION_TYPES.FETCH_STYLE_ERROR, {error}));
    }
}

async function requestMapStyle (styleUrl: string) {
    try {
        const data = await axios.get(styleUrl);
        return data.data;
    } catch (e) {
        return {}
    }
}
